import * as Sentry from "@sentry/react";
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { RatingCard } from "../../../pages/contract/contractDetails/receiverInfo/ShowFeedbackAndReview/ratingCard";
import { fetchFeedbackReview } from "../../../setup/api/services/feedbackAndReview";
import { getBasicUserDetailsById } from "../../../setup/api/services/user";
import {
  IUserInfoResponse,
  IUserInfoResponseData,
} from "../../../setup/api/services/user/models";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import Paginations from "../../common/Pagination";
import Spinner from "../../common/Spinner";
import { EmptyFeedbackList } from "./emptyFeedbackList/emptyFeedackList";
import ListFeedbackItem from "./listFeedbackItem";
import styles from "./styles.module.scss";

const FeedBackReviews = (): JSX.Element => {
  const [page, setPage] = useState(1);
  const [pagesCount, setPagesCount] = useState(1);

  const pageSize = 10;
  const [loading, setLoading] = useState<boolean>(false);
  const [feedbackReview, setFeedbackReview] = useState([]);
  const [userDetials, setUserDetials] = useState<IUserInfoResponseData>();
  const { t } = useTranslation();

  const userId = AuthConfig?.getUserInfo()?.id;

  const fetchListFeedbackReview = useCallback(async (page) => {
    try {
      setLoading(true);
      const response = await fetchFeedbackReview(userId, page - 1, pageSize);
      setFeedbackReview(response.data.content);
      setPagesCount(response.data.totalPages);
    } catch (error) {
      Sentry.captureException(error);
      console.error;
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchListFeedbackReview(page);
  }, [page, fetchListFeedbackReview]);

  useEffect(() => {
    fetchUserBasicInfo();
  }, []);

  const handlePaginationChange = (value: number) => {
    setPage(value);
  };

  const fetchUserBasicInfo = useCallback(async () => {
    if (userId) {
      try {
        const response: IUserInfoResponse = await getBasicUserDetailsById(
          userId
        );
        if (response) {
          setUserDetials(response.data);
        }
      } catch (error) {
        Sentry.captureException(error);
        console.error(error);
      }
    }
  }, [userId]);

  if (loading)
    return (
      <div className={classNames(styles.container, styles.center)}>
        <Spinner />
      </div>
    );

  return (
    <div className={classNames(styles.container)}>
      <h2 className={styles.mb2}>{t("lbl_profile_list_reviews")}</h2>
      {feedbackReview.length !== 0 ? (
        <>
          <div className={classNames(styles.container__list)}>
            <RatingCard
              feedbackReviewCount={feedbackReview.length}
              feedbackOverallRatingScore={
                userDetials?.profile?.feedbackOverallRatingScore
              }
            />
          </div>
          {feedbackReview.map((item: any) => {
            return <ListFeedbackItem key={item.id} item={item} />;
          })}
          <div className={styles.mt2}>
            <Paginations
              length={feedbackReview.length}
              page={page}
              pagesCount={pagesCount}
              handlePaginationChange={handlePaginationChange}
            />
          </div>
        </>
      ) : (
        <EmptyFeedbackList />
      )}
    </div>
  );
};

export default FeedBackReviews;
